<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Estados financieros</li>
      </template>
      <template slot="title">
        Estados financieros
      </template>
      <template slot="body">
        <FPEmbebed></FPEmbebed>
      </template>      
    </GenericPage>
  </div>
</template>

<script>
import FPEmbebed from "../components/financial-page/FPEmbebed.vue";
import GenericPage from "./new-portal-views/GenericPage.vue";

export default {
  name: "ComissionsPage",
  components: {
    FPEmbebed,
    GenericPage
},
}
</script>
